// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"1e3d2c92","246":"70007370","473":"c1515e63","510":"63da0161","578":"94bdb5b9","802":"529c032e","814":"cff79005","829":"1f6ba26d","927":"f415151a","942":"ec3a7343"}[chunkId] + ".chunk.js";
};